module.exports = __webpack_public_path__ + "97c56e3c8824bc10a355a839714511be.pdf";